import L from 'leaflet';
import ConversionFactors from 'utils/personalizer/ConversionFactors';
import 'geodesy_latlon_vector3d';
import 'geodesy_dms';
import 'geodesy_latlon_ellipsodial';
import LatLon from 'geodesy_latlon_vincenty';

var mapUtil = () => {};

mapUtil.MaxDistance = 999;

mapUtil.Radius = {
    KILOMETERS: 6371,
    MILES: 3959
};

mapUtil.ZoomLevel = {
    MAX: 9,
    FAR: 10,
    MEDIUM: 12,
    CLOSE: 13
};

mapUtil.LowestHeatmapZoomLevel = 9;

mapUtil.Layers = {
    LAYER_DISTANCE_CLOSE: 'distanceLayerClose',
    LAYER_DISTANCE_MEDIUM: 'distanceLayerMedium',
    LAYER_DISTANCE_FAR: 'distanceLayerFar',
    LAYER_DISTANCE_MAX: 'distanceLayerMax',
    LAYER_MARKERS: 'markerLayer',
    LAYER_POSITION: 'positionLayer',
    POPULAR_AREAS: 'POPULAR_AREAS',
    LAYER_ELEVATION_SELECTION: 'elevationLayer',
    CUSTOM_POINT_LAYER: 'CUSTOM_POINT_LAYER',
    LAYER_POLYLINE_OVERLAY: 'polylineOverlayLayer',
    LAYER_TOOLTIP: 'layerTooltip'
};

mapUtil.calculateBoundingBoxAreaInKM = function calculateBoundingBoxAreaInKM(north, south, east, west) {
    var heightOfBoxInKm = this.calculateDistanceBetweenPointsInKM(north, west, south, west),
        widthOfBoxInKm = this.calculateDistanceBetweenPointsInKM(north, west, north, east),
        boundingBoxArea = heightOfBoxInKm * widthOfBoxInKm;
    return boundingBoxArea;
};

mapUtil.calculateDistanceBetweenPointsInKM = function calculateDistanceBetweenPointsInKM(
    startLat,
    startLng,
    endLat,
    endLng
) {
    var p1 = new LatLon(startLat, startLng),
        p2 = new LatLon(endLat, endLng);

    return p1.distanceTo(p2) * ConversionFactors.MetersToKm;
};

mapUtil.calculateDistanceBetweenPointsInMeters = function calculateDistanceBetweenPointsInMeters(
    startLat,
    startLng,
    endLat,
    endLng
) {
    var p1 = new LatLon(startLat, startLng),
        p2 = new LatLon(endLat, endLng);

    return p1.distanceTo(p2);
};

mapUtil.calculateDistanceFromCollectionOfLatLngs = function calculateDistanceFromCollectionOfLatLngs(collection) {
    var distance = 0;

    if (collection) {
        for (var i = 0, len = collection.length; i < len; i += 1) {
            var current = collection[i],
                next = collection[i + 1];
            if (current && next) {
                distance += this.calculateDistanceBetweenPointsInMeters(current.lat, current.lng, next.lat, next.lng);
            }
        }
    }

    return distance;
};

mapUtil.calculateDestinationPoint = function calculateDestinationPoint(point, dist, bearing) {
    point = new LatLon(point.lat, point.lng);
    var destinationPoint = point.destinationPoint(dist, bearing);

    return {
        lat: destinationPoint.lat,
        lng: destinationPoint.lon
    };
};

mapUtil.calculateBearingOfPoints = function(start, end) {
    var p1 = new LatLon(start.lat, start.lng),
        p2 = new LatLon(end.lat, end.lng);

    return p1.finalBearingTo(p2);
};

/**
 * This function is from Google's polyline utility.
 * @param encodedSamples - The encodedSamples attribute from GPolyline
 */
mapUtil.decodeLine = function(encodedSamples) {
    var index = 0;
    var decodedSamples = [];
    var lat = 0;
    var lng = 0;
    if (encodedSamples && encodedSamples != undefined) {
        var len = encodedSamples.length;
        while (index < len) {
            var charVal;
            var offset = 0;
            var value = 0;
            do {
                charVal = encodedSamples.charCodeAt(index++) - 63;
                value |= (charVal & 0x1f) << offset;
                offset += 5;
            } while (charVal >= 0x20);
            var decodedLat = value & 1 ? ~(value >> 1) : value >> 1;
            lat += decodedLat;

            offset = 0;
            value = 0;
            do {
                charVal = encodedSamples.charCodeAt(index++) - 63;
                value |= (charVal & 0x1f) << offset;
                offset += 5;
            } while (charVal >= 0x20);
            var decodedLng = value & 1 ? ~(value >> 1) : value >> 1;
            lng += decodedLng;

            decodedSamples.push([lat * 1e-5, lng * 1e-5]);
        }
    }
    return decodedSamples;
};

mapUtil.indexOfClosestPoint = function(latLngs, latlng, precision, skipRecursive) {
    let index = -1,
        i,
        truncatedLatlng = this.truncateLatLng(latlng, precision);

    if (latLngs && latLngs.length >= 2) {
        // We create new polyline objects using the 2 points. That way we can then
        // use it's bounds object to see if the latlng is within it's bounds.
        for (i = 0; i < latLngs.length - 1; i++) {
            if (latLngs[i] && latLngs[i + 1]) {
                let start = this.truncateLatLng(latLngs[i], precision);
                let end = this.truncateLatLng(latLngs[i + 1], precision);
                if (
                    this.isPointsEqual(start, truncatedLatlng, precision) ||
                    this.isPointsEqual(end, truncatedLatlng, precision) ||
                    L.polyline([start, end])
                        .getBounds()
                        .contains(truncatedLatlng)
                ) {
                    index = i + 1;
                    break;
                }
            }
        }

        if (index === -1 && !skipRecursive) {
            if (precision > 2) {
                // We can't find this position, most likely due to precision between provider and leaflet.
                // Lets decrement the precision and try again.
                index = this.indexOfClosestPoint(latLngs, latlng, precision - 1);
            } else {
                index = latLngs.length - 1; //last lat lng pair of task array
            }
        }
    }

    return index;
};

/**
 * Returns a point on the polyline made up of latLngs closest to the latlng passed in
 *
 * @param latLngs: array of Leaflet latLngs that represent a polyline
 * @param latLng: the lat lng values of the point you want to place on the polyline
 * @param index: the index of the closest lat,lng point in latLngs to latlng. Found using mapUtil.indexOfClosestPoint
 * @param map: Leaflet map object
 * @return Leaflet LatLng corresponding to the closest point on the polyline to the latlng passed in
 */
mapUtil.findPointOnPolyline = function(latLngs, latlng, index, crs, zoom) {
    var polylinePoint,
        polylineLatLng,
        x1,
        y1,
        x2,
        y2,
        px,
        py,
        t,
        start = latLngs[index - 1],
        end = latLngs[index];

    //check to see if latlng is equal to start or end
    if (start.equals(latlng)) {
        polylineLatLng = start;
    } else if (end.equals(latlng)) {
        polylineLatLng = end;
    } else if (start.equals(end)) {
        polylineLatLng = start;
    } else {
        //convert start, end, latlng to x,y values
        x1 = crs.latLngToPoint(start, zoom).x; //lon
        y1 = crs.latLngToPoint(start, zoom).y; //lat
        x2 = crs.latLngToPoint(end, zoom).x; //lon
        y2 = crs.latLngToPoint(end, zoom).y; //lat
        px = crs.latLngToPoint(latlng, zoom).x; //lon
        py = crs.latLngToPoint(latlng, zoom).y; //lat

        //dot product of vector from start to p and vector from start to end divided by squared magnitude of vector from start to end
        t = ((px - x1) * (x2 - x1) + (py - y1) * (y2 - y1)) / (Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)); //normalized distance of start to closest point on line

        if (t > 1.0) {
            polylineLatLng = end;
        } else if (t < 0.0) {
            polylineLatLng = start;
        } else {
            polylinePoint = {
                x: x1 + t * (x2 - x1),
                y: y1 + t * (y2 - y1)
            };
            //convert polylinePoint to polylineLatLng
            polylineLatLng = crs.pointToLatLng(polylinePoint, zoom);
        }
    }

    return polylineLatLng.wrap();
};

mapUtil.isPointsEqual = function(p, p2, precision) {
    return (
        this.roundPointToSpecified(p.lat, precision) === this.roundPointToSpecified(p2.lat, precision) &&
        this.roundPointToSpecified(p.lng, precision) === this.roundPointToSpecified(p2.lng, precision)
    );
};

mapUtil.truncateLatLng = function(latlng, p) {
    return L.latLng(this.roundPointToSpecified(latlng.lat, p), this.roundPointToSpecified(latlng.lng, p));
};

mapUtil.roundPointToSpecified = function roundPointToSpecified(n, p) {
    return Math.round(Math.pow(10, p) * n) / Math.pow(10, p);
};

export default mapUtil;
